/* eslint-env browser */
import * as React from 'react'

import { getCDNUrl } from '../../../../../../shared/services/media-helper'
import withTranslator from '../TranslatorProvider'

const PropTypes = require('prop-types')

const UnitsService = require('../../../../client/clientjs/services/units-service')

const LikeButton = require('../like-button')

class CatchItem extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {}
    this.onClick = this.onClick.bind(this)
  }

  onClick(e) {
    const { fishCatch, onClick } = this.props
    if (onClick && fishCatch && fishCatch.id) {
      onClick(e, fishCatch.id)
    }
  }

  render() {
    const { userSettings, actor, fishCatch, isLoggedIn, locale, displayLikes, simpleGrid, translate } = this.props

    const firstMedia = fishCatch.medias.sort((a, b) => a.order - b.order)[0]
    let imgUrl
    if (firstMedia) {
      imgUrl = getCDNUrl(firstMedia, 'small')
    }
    if (!imgUrl) {
      if (fishCatch.fish && fishCatch.fish.medias && fishCatch.fish.medias.length > 0) {
        imgUrl = fishCatch.fish.medias[0].url_300 || fishCatch.fish.medias[0].url_600 || fishCatch.fish.medias[0].url
      }
    }
    if (!imgUrl) {
      imgUrl = 'https://statics.fishfriender.com/statics/placeholder_fish.png'
    }
    const fishWeight = fishCatch.weight
    const fishSize = fishCatch.size
    const { released } = fishCatch

    let fishName
    if (fishCatch.fish) {
      fishName = (fishCatch.fish.names.find(elt => elt.locale.indexOf(locale) === 0) || {}).value || ''
    }
    if (!fishName || fishName.length === 0) {
      fishName = fishCatch.speciesCustomName
    }

    const subWeightSizes = []
    if (fishWeight) {
      subWeightSizes.push(UnitsService.massInUserSettings(fishWeight, locale, userSettings, { withUnit: true }))
    }
    if (fishSize) {
      subWeightSizes.push(UnitsService.sizeInUserSettings(fishSize, locale, userSettings, { withUnit: true }))
    }

    const currentUserLiked = !!fishCatch.currentUserLikeId

    return (
      <div style={{ textAlign: 'center' }} className="animated fadeIn">
        <a
          href={`/users/${actor.id}/catches/${fishCatch.id}`}
          target="_blank"
          rel="noopener noreferrer"
          onClick={this.onClick}
        >
          <figure className="image is-square has-hover-overlay is-overflow-hidden">
            <img className="has-object-fit-cover" src={imgUrl} alt={fishName} />
            {!simpleGrid && (
              <div className="is-overlay">
                <div className="overlay-text is-size-8">
                  <b>{fishName}</b>
                  {subWeightSizes.length > 0 && ` - ${subWeightSizes.join(', ')}`}
                  <br />
                  {typeof released === 'boolean' && (
                    <span>
                      <i className={released ? 'fas fa-heart' : 'fal fa-heart'} />
                      &nbsp;
                      {translate(`catchItem.${released ? 'releasedStatus.true' : 'releasedStatus.false'}`)}
                    </span>
                  )}
                  <br />
                  {new Date(fishCatch.date).toLocaleDateString()}
                </div>
              </div>
            )}
          </figure>
        </a>
        {displayLikes && (
          <div style={{ paddingTop: 8 }}>
            <LikeButton
              locale={locale}
              likesNumber={fishCatch.likesCount || 0}
              currentUserLike={currentUserLiked ? { id: fishCatch.currentUserLikeId } : undefined}
              likeable="fishCatch"
              likeableId={fishCatch.id}
              isLoggedIn={isLoggedIn}
              size="small"
            />
          </div>
        )}
      </div>
    )
  }
}

CatchItem.propTypes = {
  userSettings: PropTypes.object,
  locale: PropTypes.string.isRequired,
  translate: PropTypes.func.isRequired,
  actor: PropTypes.object.isRequired,
  fishCatch: PropTypes.object.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  displayLikes: PropTypes.bool,
  simpleGrid: PropTypes.bool,
  onClick: PropTypes.func,
}

CatchItem.defaultProps = {
  userSettings: undefined,
  displayLikes: true,
  simpleGrid: false,
  onClick: null,
}

module.exports = withTranslator(CatchItem)
